import type { Component } from 'vue'
import { createSalaryDashboardConfig } from './dashboards/salary'
import { createWorkforceDashboardConfig } from './dashboards/workforce'
import { createDeiDashboardConfig } from './dashboards/dei'
import { createRetentionDashboardConfig } from './dashboards/retention'
import { createAbsenteeismDashboardConfig } from './dashboards/absenteeism'
import { createPayrollDashboardConfig } from './dashboards/payroll'
import { createCareerDashboardConfig } from './dashboards/career'
import { createJobsDashboardConfig } from './dashboards/jobs'
import { createSpeedDashboardConfig } from './dashboards/speed'
import { createFunnelDashboardConfig } from './dashboards/funnel'
import { createSourcingDashboardConfig } from './dashboards/sourcing'
import AnalyticsModuleComponentsSingle from '~/components/Analytics/Module/Components/Single.vue'
import AnalyticsModuleComponentsDouble from '~/components/Analytics/Module/Components/Double.vue'
import AnalyticsModuleComponentsTop from '~/components/Analytics/Module/Components/Top.vue'
import AnalyticsModuleComponentsPyramid from '~/components/Analytics/Module/Components/Pyramid.vue'
import AnalyticsModuleComponentsDistribution from '~/components/Analytics/Module/Components/Distribution.vue'
import AnalyticsModuleComponentsLargeChart from '~/components/Analytics/Module/Components/LargeChart.vue'
import { DataType } from '~/types/analytics'
import { DashboardModuleType, type DashboardConfig } from '~/types/dashboards'

export enum Dashboard {
  WORKFORCE = 'WORKFORCE',
  DIVERSITY = 'DIVERSITY',
  RETENTION = 'RETENTION',
  ABSENTEEISM = 'ABSENTEEISM',
  PAYROLL = 'PAYROLL',
  SALARY = 'SALARY',
  CAREER = 'CAREER',
  JOBS = 'JOBS',
  FUNNEL = 'FUNNEL',
  SOURCING = 'SOURCING',
  SPEED = 'SPEED'
}

export const MODULE_CATEGORIES = [
  {
    title: 'workforce',
    modules: [
      Dashboard.WORKFORCE,
      Dashboard.DIVERSITY,
      Dashboard.RETENTION,
      Dashboard.ABSENTEEISM
    ]
  },
  {
    title: 'employee',
    modules: [
      Dashboard.SALARY,
      Dashboard.PAYROLL,
      Dashboard.CAREER,
      Dashboard.RETENTION
    ]
  },
  {
    title: 'talent',
    modules: [
      Dashboard.JOBS,
      Dashboard.SPEED,
      Dashboard.FUNNEL,
      Dashboard.SOURCING
    ]
  }
]

export const MODULE_COMPONENT_BY_TYPE: {
  [key in DashboardModuleType]: Component
} = {
  [DashboardModuleType.SINGLE]: AnalyticsModuleComponentsSingle,
  [DashboardModuleType.DOUBLE]: AnalyticsModuleComponentsDouble,
  [DashboardModuleType.TOP]: AnalyticsModuleComponentsTop,
  [DashboardModuleType.PYRAMID]: AnalyticsModuleComponentsPyramid,
  [DashboardModuleType.DISTRIBUTION]: AnalyticsModuleComponentsDistribution,
  [DashboardModuleType.LARGE_CHART]: AnalyticsModuleComponentsLargeChart
}

export const DASHBOARDS_CONFIG_BY_ID: {
  [key in Dashboard]: {
    title: string
    slug: string
    dataType: DataType
    createConfig: () => DashboardConfig
  }
} = {
  [Dashboard.WORKFORCE]: {
    title: 'workforce',
    slug: 'workforce',
    dataType: DataType.EMPLOYEE,
    createConfig: createWorkforceDashboardConfig
  },
  [Dashboard.DIVERSITY]: {
    title: 'diversity',
    slug: 'dei',
    dataType: DataType.EMPLOYEE,
    createConfig: createDeiDashboardConfig
  },
  [Dashboard.RETENTION]: {
    title: 'retention',
    slug: 'retention',
    dataType: DataType.EMPLOYEE,
    createConfig: createRetentionDashboardConfig
  },
  [Dashboard.ABSENTEEISM]: {
    title: 'absenteeism',
    slug: 'absenteeism',
    dataType: DataType.EMPLOYEE,
    createConfig: createAbsenteeismDashboardConfig
  },
  [Dashboard.PAYROLL]: {
    title: 'payroll',
    slug: 'payroll',
    dataType: DataType.EMPLOYEE,
    createConfig: createPayrollDashboardConfig
  },
  [Dashboard.SALARY]: {
    title: 'salary',
    slug: 'salary',
    dataType: DataType.EMPLOYEE,
    createConfig: createSalaryDashboardConfig
  },
  [Dashboard.CAREER]: {
    title: 'career',
    slug: 'career',
    dataType: DataType.EMPLOYEE,
    createConfig: createCareerDashboardConfig
  },
  [Dashboard.JOBS]: {
    title: 'jobs',
    slug: 'jobs',
    dataType: DataType.RECRUITMENT,
    createConfig: createJobsDashboardConfig
  },
  [Dashboard.FUNNEL]: {
    title: 'funnel',
    slug: 'funnel',
    dataType: DataType.RECRUITMENT,
    createConfig: createFunnelDashboardConfig
  },
  [Dashboard.SOURCING]: {
    title: 'sourcing',
    slug: 'sourcing',
    dataType: DataType.RECRUITMENT,
    createConfig: createSourcingDashboardConfig
  },
  [Dashboard.SPEED]: {
    title: 'speed',
    slug: 'speed',
    dataType: DataType.RECRUITMENT,
    createConfig: createSpeedDashboardConfig
  }
}
